import React from "react";
import { useSearchParams } from "react-router-dom";
import { Radar } from "lucide-react";
import { PageHeader } from "../lib/ui";
import TraceabilityView from "../components/supplychain/TraceabilityView";

export default function Traceability() {
  const [params, setParams] = useSearchParams();
  const productId = params.get("product") || "";
  return (
    <div className="animate-fade-up pb-24 lg:pb-2" data-testid="traceability-page">
      <PageHeader icon={Radar} title="Telusur Rantai Pasok" subtitle="Timeline operasional lengkap setiap item — dari Supplier hingga HPP" />
      <div className="mt-5">
        <TraceabilityView key={productId} initialProductId={productId} onSelectProduct={(pid) => setParams({ product: pid })} />
      </div>
    </div>
  );
}
